export enum LocalesEnum {
  en = 'en',
  de = 'de',
  es = 'es',
  it = 'it',
  pt = 'pt',
  nl = 'nl_NL',
  fr = 'fr-FR',
}
